const PALETTE = [
  '#2563eb',
  '#7c3aed',
  '#0891b2',
  '#0d9488',
  '#d97706',
  '#dc2626',
  '#db2777',
  '#65a30d',
  '#0ea5e9',
  '#9333ea',
];

export function makeClusterColor(
  clusters: { slug: string; color?: string }[]
): (slug: string) => string {
  const order = clusters.map(c => c.slug);
  return (slug: string): string => {
    const c = clusters.find(x => x.slug === slug);
    if (c?.color) return c.color;
    const i = order.indexOf(slug);
    return PALETTE[(i < 0 ? 0 : i) % PALETTE.length];
  };
}
